import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { AllClinicStatistics, ClinicStatisticsNew } from 'generated/api';
import { createContext, useContext, useEffect, useState } from 'react';
import { api } from 'careand-redux/api/ApiThunks';

export type Statistics = {
  data?: ClinicStatisticsNew;
  allData?: AllClinicStatistics;
};

export const StatisticsContext = createContext<Statistics>({});

export const useStatistics = () => {
  return useContext(StatisticsContext);
};

export const useLoadStatistics = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState<Statistics>({});

  useEffect(() => {
    dispatch(api.Stats.getNewClinicStats()).then((data) => {
      if (data) {
        setData((prev) => ({ ...prev, data }));
      }
    });
  }, []);

  return data;
};
